import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import { ChatlikeNotificationBanner } from '@src/components/notifications/ChatlikeNotificationBanner'
import { userSelector } from '@src/selectors/app'
import { recordByosVideoCallsUpsellInteraction } from '../../utils'
import { ByosVideoCallsUpsellStep } from '../../constants'

export const FreeConsultationChatlikeBanner = () => {
  const user = useSelector(userSelector)
  const primaryCoachingKind = user?.primaryCoachingKind
  const showInsuranceUi = primaryCoachingKind?.insuranceReimbursable === true
  const navigation = useNavigation()
  const [dismissed, setDismissed] = useState(false)

  if (!showInsuranceUi || dismissed) {
    return null
  }

  const onAction = () => {
    if (user) {
      recordByosVideoCallsUpsellInteraction(
        ByosVideoCallsUpsellStep.FreeConsultationChatlikeNotification,
        user.id,
      )
    }
    navigation.navigate('InsuranceQuestionnaire', {
      skipIntroScreen: true,
    })
    setDismissed(true)
  }

  const onDismiss = () => {
    if (user) {
      recordByosVideoCallsUpsellInteraction(
        ByosVideoCallsUpsellStep.FreeConsultationChatlikeNotification,
        user.id,
      )
    }
    setDismissed(true)
  }

  return (
    <ChatlikeNotificationBanner
      action={onAction}
      dismiss={onDismiss}
      content="Claim Your FREE Expert Nutritionist Consultation Today."
      actionButtonLabel="Schedule Free Call"
    />
  )
}
